import { render, staticRenderFns } from "./PartnerInfoGrid.vue?vue&type=template&id=130c9460&scoped=true"
import script from "./PartnerInfoGrid.vue?vue&type=script&lang=js"
export * from "./PartnerInfoGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130c9460",
  null
  
)

export default component.exports